(function () {
  'use strict';

  angular
    .module('itecAdministracio.productes.main')
    .config(config);

  function config($stateProvider, $urlRouterProvider) {

    $stateProvider
      .state('productes.main', {
        url: '/',
        params: {
          tipus: 0,
          nom: '',
          submenuInfo: {
            visible: true,
            left: {
              visible: true,
              visibleMenu: true,
              collapsable: true,
              collapsed: false,
              name: 'DEFAULT_PRODUCTES',
              nameCollapsed: 'DEFAULT_PRODUCTES',
              icon: 'view_list',
              columns: 4,
              columnsCollapsed: 0
            },
            content: {
              visible: true,
              collapsable: true,
              collapsed: true,
              columnsCollapsed: 0,
              menu: {
                minColumns: 3,
                minOptions: 2
              },
              dynamicMenu: {
                minColumns: 3,
                minOptions: 2
              }
            },
            right: {
              visible: false,
              visibleMenu: false,
            }
          }
        },
        views: {
          'headerSubmenu@': {
            templateUrl: 'shared/header-submenu/headerSubmenu.tpl.html',
            controller: 'HeaderSubmenuCtrl',
            controllerAs: 'vm',
            resolve: {
              optionsHeaderSubmenuData: function(permisosProductesHeaderSubmenuLinksValue) {
                return permisosProductesHeaderSubmenuLinksValue;
              }
            }
          },
          'leftSide': {
            templateUrl: 'productes/main/llista/llista.tpl.html',
            controller: 'ProductesMainLlistaCtrl',
            controllerAs: 'ctrl',
            resolve: {
                  llistaaplicacions:function(AplicacioFactory,$rootScope) {
                    if (!angular.isUndefined($rootScope.permisos) && $rootScope.permisos.PRODUCTE.read)
                    {
                      return AplicacioFactory.getAll().catch(function(){});
                    }
                    else{
                      return undefined;
                    }
                  }
            }
          }
        }
      }
      )
      .state('productes.main.submain', {
        url: '{idProducte:[0-9]{0,32}}',
        abstract: true,
        views: {
          'content@productes': {
            templateUrl: 'shared/submain/submain.tpl.html'
          }
        },
        breadcrumb: {
          dynamicText: '{{breadcrumbText}}',
          stateName: 'productes.main.submain.dades',
          textParam: {paramName: 'label', paramValue: '{{producteData.data.nom}}'}
        },
        resolve: {
          producteData: function(ProducteFactory, $stateParams) {
            if ($stateParams.isNew){
              return {};
            }
            else if (!angular.isUndefined($stateParams.idProducte)
                      && $stateParams.idProducte !== null
                      && $stateParams.idProducte) {
              return ProducteFactory.get($stateParams.idProducte).catch(function(){});
            }
            else {
              return {};
            }
          },
          breadcrumbText: function($stateParams){
            if (angular.isUndefined($stateParams.idProducte) || $stateParams.idProducte === '') {
              return 'BREADCRUMB_FORMULARI_CREACIO';
            }
            else {
              return 'BREADCRUMB_LABEL';
            }
          }
        }
      });
  }
}());
